<template>
  <div class="mt-3">
    <h2 class="fw-bold">
      <span class="text-teal">Preenchimento de Orçamentos</span>
    </h2>
  </div>
  <div class="card border-start border-start-width-3 border-start-teal">
    <form @submit.prevent="seach">
      <div class="card-body">
        <div class="row g-3">
          <div class="col-md-3">
            <select
              class="form-select select2"
              v-model="v$.filters.codCCustoPai.$model"
              v-select2
            >
              <option value="" disabled>
                Selecione um Centro de Custo (Pai)
              </option>
              <option
                v-for="(centroCustoPai, index) in centrosCustosPais"
                :key="index"
                :value="centroCustoPai.codCCustoPai"
                :title="`${centroCustoPai.codCCustoPai} - ${centroCustoPai.nomeCCustoPai}`"
              >
                {{ centroCustoPai.codCCustoPai }} -
                {{ centroCustoPai.nomeCCustoPai }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <select
              class="form-select select2"
              v-model="v$.filters.codCCustoFilho.$model"
              v-select2
            >
              <option value="" disabled>
                Selecione um Centro de Custo (Filho)
              </option>
              <option
                v-for="(centroCustoFilho, index) in centrosCustosFilhos"
                :key="index"
                :value="centroCustoFilho.codCCustoFilho"
                :title="`${centroCustoFilho.codCCustoFilho} - ${centroCustoFilho.nomeCCustoFilho}`"
              >
                {{ centroCustoFilho.codCCustoFilho }} -
                {{ centroCustoFilho.nomeCCustoFilho }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <select
              class="form-select select2"
              v-model="v$.filters.orcamentoId.$model"
              @change="alterarOrcamentoSelecionado"
              v-select2
            >
              <option value="" disabled>Selecione o Ano</option>
              <option
                v-for="orcamento in orcamentos"
                :key="orcamento.id"
                :value="orcamento.id"
                :title="orcamento.ano"
              >
                {{ orcamento.ano }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <select
              class="form-select select2"
              v-model="v$.filters.periodoOrcamento.$model"
              v-select2
            >
              <option value="" disabled>Considerar o Valor</option>
              <option value="1" title="Proposto">Proposto</option>
              <option value="2" title="Reformulado">Reformulado</option>
            </select>
          </div>
          <div class="col-md-2">
            <button
              type="submit"
              class="btn btn-success w-100"
              title="Buscar"
              :disabled="v$.$invalid || seachData"
            >
              <span v-if="seachData">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>Buscar</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <PreenchimentoResult
    :seachData="seachData"
    :filters="filters"
    :textoInformativo="textoInformativo"
    @seachData="seachData = false"
  />
</template>

<script>
import PreenchimentoResult from '@/components/preenchimento/PreenchimentoResult.vue'
import { mapGetters } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import select2 from 'select2'
import PeriodoOrcamentoEnum from '@/enum/periodoOrcamentoEnum'

export default {
  name: 'Preenchimento',

  components: {
    PreenchimentoResult,
  },

  setup() {
    return { v$: useVuelidate() }
  },

  data() {
    return {
      centrosCustosPais: [],
      centrosCustosFilhos: [],
      orcamentos: [],
      filters: {
        codCCustoPai: '',
        codCCustoFilho: '',
        orcamentoId: '',
        periodoOrcamento: '',
      },
      textoInformativo: '',
      seachData: false,
    }
  },

  computed: {
    ...mapGetters(['orcamentoSelecionado']),

    periodoOrcamentoProposta() {
      return (
        this.orcamentoSelecionado.periodoOrcamento ===
        PeriodoOrcamentoEnum.PROPOSTA
      )
    },

    periodoOrcamentoReformulacao() {
      return (
        this.orcamentoSelecionado.periodoOrcamento ===
        PeriodoOrcamentoEnum.REFORMULACAO
      )
    },
  },

  watch: {
    'filters.codCCustoPai': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getCentrosCustosFilhos()
        }
      },
      immediate: true,
    },
  },

  methods: {
    async getInitialRegistros() {
      try {
        this.filters.codCCustoPai = this.$route.query.codCCustoPai

        await this.getCentrosCustosPais()
        await this.getOrcamentos()

        this.filters.codCCustoFilho = this.$route.query.codCCustoFilho
        this.filters.orcamentoId = this.orcamentoSelecionado.id

        if (this.periodoOrcamentoProposta) {
          this.filters.periodoOrcamento = PeriodoOrcamentoEnum.PROPOSTA
        }
        if (this.periodoOrcamentoReformulacao) {
          this.filters.periodoOrcamento = PeriodoOrcamentoEnum.REFORMULACAO
        }

        this.seach()
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getCentrosCustosPais() {
      try {
        this.centrosCustosPais = await this.$store.dispatch(
          'getCentrosCustosPais',
        )
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getCentrosCustosFilhos() {
      try {
        this.centrosCustosFilhos = await this.$store.dispatch(
          'getCentrosCustosFilhos',
          this.filters.codCCustoPai,
        )
        this.filters.codCCustoFilho = ''
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getOrcamentos() {
      try {
        this.orcamentos = await this.$store.dispatch('getOrcamentos')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async seach() {
      if (!this.v$.$invalid) {
        this.montarTextoInformativo()
        this.seachData = true
      }
    },

    montarTextoInformativo() {
      const centroCustoPai = this.centrosCustosPais.find(
        (centroCustoPai) =>
          centroCustoPai.codCCustoPai === this.filters.codCCustoPai,
      )

      const centroCustoFilho = this.centrosCustosFilhos.find(
        (centroCustoFilho) =>
          centroCustoFilho.codCCustoFilho === this.filters.codCCustoFilho,
      )

      const orcamento = this.orcamentos.find(
        (orcamento) => orcamento.id === this.filters.orcamentoId,
      )

      const periodoOrcamento =
        Number(this.filters.periodoOrcamento) === PeriodoOrcamentoEnum.PROPOSTA
          ? 'PROPOSTO'
          : 'REFORMULADO'

      this.textoInformativo = `Você está visualizando o orçamento (${periodoOrcamento}) do ano de ${orcamento.ano} para o centro de custo <br/> ${centroCustoPai.codCCustoPai} - ${centroCustoPai.nomeCCustoPai} => ${centroCustoFilho.codCCustoFilho} - ${centroCustoFilho.nomeCCustoFilho}`
    },

    alterarOrcamentoSelecionado(event) {
      const orcamentoSelecionado = this.orcamentos.find(
        (orcamento) => orcamento.id === event.target.value,
      )
      this.$store.dispatch('setOrcamentoSelecionado', orcamentoSelecionado)
    },
  },

  validations() {
    return {
      filters: {
        codCCustoPai: {
          required,
        },
        codCCustoFilho: {
          required,
        },
        orcamentoId: {
          required,
        },
        periodoOrcamento: {
          required,
        },
      },
    }
  },

  mounted() {
    this.getInitialRegistros()

    window.$('.select2').select2({ width: '100%' })
  },
}
</script>
